import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';

const useGetTransferWorkspace = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [workspace, setWorkspace] = useState(null);

  const getTransferWorkspace = useCallback(
    guid => {
      if (!guid) return Promise.resolve(null);

      setLoading(true);

      return axiosClient
        .get('Operation/Transfer/Workspace', {
          params: { guid },
        })
        .then(res => {
          if (res.status === 200) {
            const value = res.data?.value ?? null;
            setWorkspace(value);
            return value;
          }

          enqueueSnackbar(res?.message, { variant: 'error' });
          return null;
        })
        .catch(err => {
          enqueueSnackbar(err?.message, { variant: 'error' });
          return null;
        })
        .finally(() => setLoading(false));
    },
    [enqueueSnackbar],
  );

  return { getTransferWorkspace, loading, workspace, setWorkspace };
};

export default useGetTransferWorkspace;
